import { createSelector } from 'reselect'

const getOnboardingData = state => state.onboarding

const onboardingAddLessons = createSelector(
	[getOnboardingData],
	onboarding => ({
		selected: onboarding.selected,
	})
)

export default onboardingAddLessons
